import { AppSettings, PreviewConfig } from 'types';
import { HawksearchConfig } from 'react-hawksearch';

const getDashboardUrl = () => {
	if (window.location.href) {
		return (window.location.href.match(/https:/g) || []).length
			? process.env.REACT_APP_HAWK_DASHBOARD_SECURE_URL
			: process.env.REACT_APP_HAWK_DASHBOARD_URL;
	}
	return process.env.REACT_APP_HAWK_DASHBOARD_URL;
};

const getSearchAPIURL = () => {
	const elem = document.getElementById('react-app');
	if (elem) {
		const val = elem.getAttribute('data-hawksearch-search-api');
		if (val) {
			return val;
		} else {
			return elem.getAttribute('data-base-api');
		}
	} else {
		const elem2 = document.getElementById('react-app-autocomplete');
		if (elem2) {
			const val2 = elem2.getAttribute('data-hawksearch-search-api');
			if (val2) {
				return val2;
			} else {
				return elem2.getAttribute('data-base-api');
			}
		}
	}
	return '';
};

// handle the initial settings here
const initialContext: AppState = {
	settings: {
		timeZone: 'America/New_York',

		isBoostAndBuryEnabled: true,
		isVisibilityRulesEnabled: true,
		isPersonalizedBoostEnabled: true,
		isPopularityBoostEnabled: true,
		isItemPinEnabled: true,
		isAdvancedExplanationEnabled: true,
		isCoverageEnabled: false,
		isKeywordReplacementEnabled: true,
	},
	hawkConfig: {
		// apiUrl: process.env.REACT_APP_HAWK_API_URL,
		apiUrl: getSearchAPIURL(),
		dashboardUrl: getDashboardUrl(),
		isInPreview: true,
		searchPageUrl: 'index.html',
	},
	config: {
		apiUrl: process.env.REACT_APP_HAWK_PREVIEW_API_URL,
		addToCartURL: '',
		compareItemURL: '',
	},
};

// This is dangerous if the state ever changes. If it is ever found out that we do change AppContextState, this export of the initial state isn't sufficient.
export default initialContext;

/**
 * Interface for the global application context
 */
export interface AppState {
	settings: AppSettings;
	config: PreviewConfig;
	hawkConfig: HawksearchConfig;
}
